<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="6">
            <a-form-item :label="language['emp.apptype.apptypeName']">
              <a-input placeholder="" v-model="appTypeName" disabled="true"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="6">
            <a-form-item :label="language['emp.apptype.entrance']">
              <a-input placeholder="" v-model="entranceName" disabled="true"></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="6">
            <a-form-item :label="language['user']+language['user.column.status']">
              <a-select v-model="queryParam.status" :placeholder="language['common.pleaseChoose']+language['user']+language['user.column.status']" allowClear>
                <a-select-option value="1">{{language['downBoxValue.normal']}}</a-select-option>
                <a-select-option value="2">{{language['downBoxValue.freeze']}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>-->
<!--          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
            <a-col :md="9" :sm="24">
             <a-button type="primary" @click="searchQuery" icon="search" style="margin-left: 21px">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>

            </a-col>
          </span>-->
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
            <img v-else :src="getImgViewCode(text,applicationCode)" @click="imgView(getImgViewCode(text,applicationCode))" height="25px" width="50px" alt="" style="max-width:80px;max-height:160px;font-size: 12px;font-style: italic;cursor: pointer;"/>
          </div>
          <a-modal
            :mask="false"
            :width="1000"
            title="图片"
            :visible="previewVisible"
            :confirm-loading="false"
            :ok-button-props="{ props: { disabled: true } }"
            @cancel="handleCancel"
            :cancelText="language['common.closeButton']">
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>


      </a-table>
    </div>

  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { httpAction,getAction } from '@/api/manage'
  import { filterObj } from '@/utils/util';

  export default {
    name: 'ApptypeApplicationListForm',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
    },
    props: {
      appTypeId: String,
      appTypeName: String,
      entranceName: String,
    },
    data () {
      return {
        description: '分類應用列表',
        // 表头

        url: {
          list: '/sys/portal/sysPortalOrg/getAppTypeAppsDetail',
          
        },
        dictOptions:{},
        superFieldList:[],
        applicationCode:'hhemp',
        disableMixinCreated: true,
      }
    },
    created() {
      this.queryParam.roleId = this.roleId;
      this.loadData();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns(){
        if (this.language) {
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title: this.language['application.applicationName'],
              align: 'center',
              dataIndex: 'applicationName',
              width: 120,
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title:  this.language['application.applicationCode'],
              align: "center",
              width: 100,
              dataIndex: 'applicationCode',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            }
          ]
        }
      },

    },
    methods: {
      initDictConfig(){
      },
      getQueryParams() {
        this.queryParam.id = this.appTypeId;
        //获取查询条件
        let sqp = {}
        if(this.superQueryParams){
          sqp['superQueryParams']=encodeURI(this.superQueryParams)
          sqp['superQueryMatchType'] = this.superQueryMatchType
        }
        var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },

      // 关闭模态框
      handleCancel() {
        this.previewVisible = false;
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
